module.exports = __webpack_public_path__ + "img/chave.ef9738fe.svg";